export default function SplashScreen() {
  return (
    <div className="bg-stock flex min-h-dvh items-center justify-center">
      <p className="eyebrow">Side Action</p>
    </div>
  )
}
